class FyreFilters extends HTMLElement {
  constructor() {
    super()
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this)
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event)
    }, 500)

    const form = this.querySelector('#FacetFiltersForm')
    if (form) {
      form.addEventListener('change', this.debouncedOnChange.bind(this))
    }

    window.addEventListener('popstate', this.onHistoryChange.bind(this))
    this.bindActiveFilterButtons()
  }

  bindActiveFilterButtons() {
    const activeFilters = this.querySelectorAll('.filters__active-button')
    activeFilters.forEach((filter) => {
      filter.addEventListener('click', this.onActiveFilterClick)
    })
  }

  getSortValue() {
    const searchParams = new URLSearchParams(window.location.search)
    return searchParams.get('sort_by') || ''
  }

  onChange(event) {
    const formData = new FormData(event.target.closest('form'))
    const searchParams = new URLSearchParams(formData)
    const currentSort = this.getSortValue()
    if (currentSort) {
      searchParams.set('sort_by', currentSort)
    }
    this.renderSection(searchParams.toString())
  }

  onActiveFilterClick(event) {
    event.preventDefault()
    const url = new URL(event.currentTarget.href)
    const searchParams = new URLSearchParams(url.search)
    const currentSort = this.getSortValue()
    if (currentSort) {
      searchParams.set('sort_by', currentSort)
    }
    this.renderSection(searchParams.toString())
  }

  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || ''
    this.renderSection(searchParams)
  }

  renderSection(searchParams) {
    const collectionHandle = window.location.pathname.split('/collections/')[1]?.split('?')[0] || ''
    if (!collectionHandle) return

    const url = `/collections/${collectionHandle}?${searchParams}`

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.text()
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')

        const newProductGrid = html.querySelector('.collection__main')
        const currentProductGrid = document.querySelector('.collection__main')
        if (newProductGrid && currentProductGrid) {
          currentProductGrid.innerHTML = newProductGrid.innerHTML
        }

        const newFilters = html.querySelector('.filters')
        const currentFilters = document.querySelector('.filters')
        if (newFilters && currentFilters) {
          currentFilters.innerHTML = newFilters.innerHTML
        }

        this.updateURLHash(searchParams)
        this.bindActiveFilterButtons()
      })
      .catch((error) => {
        console.error('Error:', error)
      })
  }

  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams ? '?' + searchParams : ''}`
    )
  }
}

customElements.define('fyre-filters', FyreFilters)

function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}
